import { TextArea } from 'macaron-frontend-ui'
import { useDebouncedOnChange } from '../../hooks/useDebounce'
import {
  useRequestsAndCommentsError,
  useSetRequestsAndComments,
} from '../../store/requestsAndComments'
import { Section } from '../Section'

export function RequestsAndComments() {
  return (
    <Section title="ご要望・コメント">
      <Body />
    </Section>
  )
}

function Body() {
  const { isError, error, onChange } = useBody()
  return (
    <TextArea
      onChange={onChange}
      withSpread={true}
      maxLength={200}
      placeholder="アレルギーなど（全角200文字以内）"
      isError={isError}
      errorMessage={error}
    />
  )
}

function useBody() {
  const error = useRequestsAndCommentsError() ?? ''
  const isError = error !== ''
  const set = useSetRequestsAndComments()
  const onChange = useDebouncedOnChange(set)
  return { isError, error, onChange }
}
